<template>
  <!-- <input class="w-full md:w-full py-2 h-full rounded-lg border px-2" type="text" v-model="item.answer" @blur="change(item)" @input="$emit('input',item.answer)"/> -->
  <input class="w-full md:w-full py-2 h-full rounded-lg border px-2" type="text" :value="value" @blur="change($event.target.value, Item)" @input="$emit('input',$event.target.value)"/>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    change: {
        type: Promise|Function,
        required: true,
        default: ()=> {}
    }
  },
};
</script>

<style lang="scss" scoped></style>
